export { default } from './FooterInfo';
